// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"1a966cc7","188":"8e2fc5d6","333":"124bd43a","453":"e05d0f29","675":"6c81e0e5","681":"46e3c0f8","689":"69a5c854","713":"5b1a37c4","736":"2d74b326","749":"fa006465","790":"36ae9211"}[chunkId] + ".chunk.js";
};